import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { differenceInDays } from 'date-fns';
import { defineComponent } from 'vue';
import { useI18n } from '@/shared/i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'StatusDowngradeTimer',
  props: {
    date: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useI18n = useI18n(),
      $tc = _useI18n.tc;
    defineComponent({
      name: 'StatusDowngradeTimer'
    });
    var todayTime = new Date().setHours(0, 0, 0, 0);
    var dateTime = props.date ? new Date(props.date).setHours(0, 0, 0, 0) : 0;
    var days = dateTime - todayTime > 0 ? Math.abs(differenceInDays(dateTime, todayTime)) : 0;
    return {
      __sfc: true,
      props: props,
      $tc: $tc,
      todayTime: todayTime,
      dateTime: dateTime,
      days: days,
      SIcon: SIcon
    };
  }
});